import { gql } from '@apollo/client';
import { SERVICE_PROVIDER } from '../fragments';

export const GET_SERVICE_PROVIDER = gql`
  query GetServiceProvider($id: ID!) {
    serviceProvider: getServiceProvider(id: $id) {
      ...serviceProvider
      funder {
        id
        name
      }
      geographies {
        id
        fromDate
        toDate
        programme {
          id
          name
        }
        district {
          id
          name
        }
        region {
          id
          name
        }
        province {
          id
          name
        }
        country {
          id
          name
        }
        localMunicipality {
          id
          localMunicipality
        }
        districtMunicipality {
          id
          name
        }
        city {
          id
          name
        }
        name
      }
      organisationUsersAddOns {
        id
        name
      }
      organisationUsersPlan {
        id
        name
      }
      programmes {
        id
        name
      }
    }
  }
  ${SERVICE_PROVIDER}
`;
